/* Move prices for certain products */
document.addEventListener('DOMContentLoaded', function () {
  const validClasses = [
    'silentball-grip',
    'silentball-silent-basketball',
    '3-silentball-grip-socks',
    '5-silentball-grip-socks'
  ];

  const bodyHasMatch = validClasses.some(cls => document.body.classList.contains(cls));

  if (bodyHasMatch) {
    const price = document.querySelector('.product-block--price');
    const salesPoint = document.querySelector('.product-block--sales-point');

    if (price && salesPoint && salesPoint.parentNode) {
      salesPoint.parentNode.insertBefore(price, salesPoint);
    }
  }
});

/* Custom variations in Training kit */
if (document.body.classList.contains('training-kit')) {
  const i18n = window.trainingKitI18n || {};

  var ballSize = document.querySelector('.variant-wrapper:first-child');
  if (ballSize) {
    var wrapper = document.createElement('div');
    wrapper.classList.add('selection-wrapper');
    wrapper.innerHTML = `
      <div>
        <img src="https://cdn.shopify.com/s/files/1/0935/8707/9433/files/pick-your-size-ball.png?v=1754543659"/>
      </div>
      <div>
        <span class="pick-your-size">${i18n.pick_ball_size || 'Pick SilentBall size'}</span>
        <span class="included">${i18n.ball_included || '1x Ball Included'}</span>
      </div>
      <a class="size-chart right-size-button"><span>${i18n.size_guide || 'Size guide'}</span></a>
    `;
    ballSize.prepend(wrapper);
  }

  var socksSize = document.querySelector('.variant-wrapper:nth-child(2)');
  if (socksSize) {
    var wrapper = document.createElement('div');
    wrapper.classList.add('selection-wrapper');
    wrapper.innerHTML = `
      <div>
        <img src="https://cdn.shopify.com/s/files/1/0935/8707/9433/files/pick-your-size-socks.png?v=1754547389"/>
      </div>
      <div>
        <span class="pick-your-size">${i18n.pick_socks_size || 'Pick Grip Socks size'}</span>
        <span class="included">${i18n.socks_included || '3x Pairs Included'}</span>
      </div>
      <a class="size-chart-ultimate right-size-button"><span>${i18n.size_guide || 'Size guide'}</span></a>
    `;
    socksSize.prepend(wrapper);
  }

  const labelMap = i18n.labelMap || {};

  Object.entries(labelMap).forEach(([value, [main, sub]]) => {
    const container = document.querySelector(`.variant-input[data-value="${value}"]`);
    if (container) {
      const label = container.querySelector('label');
      if (label) {
        label.innerHTML = `
          <div class="size-description">
            <span>${main}</span>
            <span>${sub}</span>
          </div>
        `;
      }
    }
  });

  const sizeTextMap = i18n.sizeTextMap || {};

  Object.entries(sizeTextMap).forEach(([dataValue, sizeText]) => {
    const container = document.querySelector(`.variant-input[data-value="${dataValue}"]`);
    if (container) {
      const lightElement = container.querySelector('.single-order-kit-item.ball .light');
      if (lightElement) {
        lightElement.textContent = sizeText;
      }
    }
  });
}

/* Training Kit before add to cart button USPs ratings */
document.addEventListener('DOMContentLoaded', function() {
  if (document.body.classList.contains('training-kit')) {
    
    var badge = document.querySelector('.jdgm-prev-badge');

    if (badge) {
      var averageRating = badge.getAttribute('data-average-rating');
      var numberOfReviews = badge.getAttribute('data-number-of-reviews');

      var ratingEl = document.querySelector('.product-cart-usps-wrapper .usp-rating');
      var reviewsEl = document.querySelector('.product-cart-usps-wrapper .usp-reviews');

      if (ratingEl && averageRating) {
        ratingEl.textContent = averageRating;
      }

      if (reviewsEl && numberOfReviews) {
        reviewsEl.textContent = numberOfReviews;
      }
    }
  }
});

/* Change Your Training Kit values based on variant selection */
document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains("training-kit")) return;

  const i18n = window.trainingKitI18n || {};
  const labelMap = i18n.labelMap || {};
  const sizeTextMap = i18n.sizeTextMap || {};
  const aliasMap = i18n.variantAliasMap || {};

  const getLabel = (key, fallback) => {
    if (sizeTextMap[key]) return sizeTextMap[key];
    if (labelMap[key]?.[0]) return labelMap[key][0];
    return fallback;
  };

  function applyVariantSubtexts() {
    document.querySelectorAll(".training-kit .variant-input[data-value]").forEach((container) => {
      const rawValue = container.getAttribute("data-value") || "";
      const canonical = aliasMap[rawValue] || rawValue;

      const pair = labelMap[canonical];
      if (!pair) return;

      const label = container.querySelector("label");
      if (!label) return;

      label.innerHTML = `
        <div class="size-description">
          <span>${pair[0]}</span>
          <span>${pair[1]}</span>
        </div>
      `;
    });
  }

  function updateText() {
    document
      .querySelectorAll('.training-kit .variant-input input[type="radio"]:checked')
      .forEach((input) => {
        const wrapper = input.closest(".variant-input");
        if (!wrapper) return;

        const value = wrapper.getAttribute("data-value") || "";

        if (wrapper.dataset.index === "option1") {
          const target = document.querySelector(".single-order-kit-item.ball .light");
          if (!target) return;

          if (value.includes("5")) target.textContent = getLabel("5 (3-11 yrs.)", "Size 5");
          else if (value.includes("6")) target.textContent = getLabel("6 (12-13 yrs.)", "Size 6");
          else if (value.includes("7")) target.textContent = getLabel("7 (14+ yrs.)", "Size 7");
        }

        if (wrapper.dataset.index === "option2") {
          const target = document.querySelector(".single-order-kit-item.socks .light");
          if (!target) return;

          if (/S\b/i.test(value)) target.textContent = getLabel("Size S", "Size S");
          else if (/M\b/i.test(value)) target.textContent = getLabel("Size M", "Size M");
          else if (/L\b/i.test(value)) target.textContent = getLabel("Size L", "Size L");
        }
      });
  }

  document
    .querySelectorAll('.training-kit .variant-input input[type="radio"]')
    .forEach((input) => {
      input.addEventListener("change", updateText);
    });

  applyVariantSubtexts();
  updateText();
});

document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains("training-kit")) return;

  const ballItem = document.querySelector(".single-order-kit-item.ball");
  const socksItem = document.querySelector(".single-order-kit-item.socks");

  const ballNotIncluded = document.querySelector(".single-order-kit-item.ball .not-included");
  const socksNotIncluded = document.querySelector(".single-order-kit-item.socks .not-included");

  const ballLight = document.querySelector(".single-order-kit-item.ball .light");
  const socksLight = document.querySelector(".single-order-kit-item.socks .light");

  const normalize = (v) => (v || "").toLowerCase().trim();

  const isBallNone = (v) => {
    const s = normalize(v);
    return s === "no ball" || s === "sin balón" || s === "sin balon";
  };

  const isSocksNone = (v) => {
    const s = normalize(v);
    return s === "no socks" || s === "sin calcetines";
  };

  const getCheckedValueForOption = (optionIndex) => {
    const checked = document.querySelector(
      `.training-kit .variant-input[data-index="${optionIndex}"] input[type="radio"]:checked`
    );
    const wrapper = checked?.closest(".variant-input");
    return wrapper?.getAttribute("data-value") || checked?.value || "";
  };

  function updateOpacity() {
    const ballValue = getCheckedValueForOption("option1");
    const socksValue = getCheckedValueForOption("option2");

    const ballNone = isBallNone(ballValue);
    const socksNone = isSocksNone(socksValue);

    if (ballItem) ballItem.style.opacity = ballNone ? "0.25" : "1";
    if (socksItem) socksItem.style.opacity = socksNone ? "0.25" : "1";

    if (ballNotIncluded) ballNotIncluded.style.display = ballNone ? "block" : "none";
    if (socksNotIncluded) socksNotIncluded.style.display = socksNone ? "block" : "none";

    if (ballLight) ballLight.style.display = ballNone ? "none" : "block";
    if (socksLight) socksLight.style.display = socksNone ? "none" : "block";
  }

  updateOpacity();

  document.querySelectorAll('.training-kit .variant-input input[type="radio"]').forEach((radio) => {
    radio.addEventListener("change", updateOpacity);
  });
});

/* Change product cart based on variant selection */
document.addEventListener("DOMContentLoaded", function () {
  const originalPriceEl = document.querySelector(".original-price");
  const totalPriceEl = document.querySelector(".total");
  const savingsEl = document.querySelector(".savings");

  const currencyCode = document.querySelector('.product-cart-wrapper')?.dataset.currency || 'EUR';

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode
    }).format(cents / 100);
  }

  function updatePrices(variant) {
    if (!variant) return;

    const price = variant.price;
    const compareAtPrice = variant.compare_at_price;

    totalPriceEl.textContent = formatMoney(price);

    if (compareAtPrice && compareAtPrice > price) {
      originalPriceEl.textContent = formatMoney(compareAtPrice);
      savingsEl.textContent = formatMoney(compareAtPrice - price);
    } else {
      originalPriceEl.textContent = '';
      savingsEl.textContent = formatMoney(0);
    }
  }

  document.addEventListener("variant:change", function (event) {
    const variant = event.detail.variant;
    updatePrices(variant);
  });

  if (window?.Shopify?.Product?.currentVariant) {
    updatePrices(window.Shopify.Product.currentVariant);
  }
});

/* Custom variations in socks and ball */
const pvI18n = window.productVariationsI18n || {};

const baseText = {
  pickYourSize: pvI18n.pick_your_size || "Pick your size",
  sizeGuide: pvI18n.size_guide || "Size guide",
  whatSizeIsRight: pvI18n.what_size_is_right || "What size is right?",

  includedPair1: pvI18n.included_pair_1 || "1x Pair Included",
  includedPairs3: pvI18n.included_pairs_3 || "3x Pairs Included",
  includedPairs5: pvI18n.included_pairs_5 || "5x Pairs Included",
  includedBall1: pvI18n.included_ball_1 || "1x Ball Included"
};

const hasAnyBodyClass = (classes) => classes.some((cls) => document.body.classList.contains(cls));

if (hasAnyBodyClass(["silentball-grip", "3-silentball-grip-socks", "5-silentball-grip-socks"])) {
  const socksLabelMap = pvI18n.socksLabelMap || {
    "Size S": ["Size S", "EU: 28-34 US: 0.5-3"],
    "Size M": ["Size M", "EU: 35-41 US: 3.5-8"],
    "Size L": ["Size L", "EU: 42-47 US: 8.5-12.5"]
  };

  Object.entries(socksLabelMap).forEach(([value, [main, sub]]) => {
    const container = document.querySelector(`.variant-input[data-value="${value}"]`);
    if (!container) return;

    const label = container.querySelector("label");
    if (!label) return;

    label.innerHTML = `
      <div class="size-description">
        <span>${main}</span>
        <span>${sub}</span>
      </div>
    `;
  });
}

if (document.body.classList.contains("silentball-grip")) {
  const socksSize = document.querySelector(".variant-wrapper:first-child");
  if (socksSize) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("selection-wrapper");
    wrapper.innerHTML = `
      <div>
        <img src="https://cdn.shopify.com/s/files/1/0935/8707/9433/files/pick-your-size-socks.png?v=1754543659"/>
      </div>
      <div>
        <span class="pick-your-size">${baseText.pickYourSize}</span>
        <span class="included">${baseText.includedPair1}</span>
      </div>
      <a class="size-chart right-size-button"><span>${baseText.sizeGuide}</span></a>
    `;
    socksSize.prepend(wrapper);
  }
}

if (document.body.classList.contains("3-silentball-grip-socks")) {
  const socksSize = document.querySelector(".variant-wrapper:first-child");
  if (socksSize) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("selection-wrapper");
    wrapper.innerHTML = `
      <div>
        <img src="https://cdn.shopify.com/s/files/1/0935/8707/9433/files/pick-your-size-socks.png?v=1754543659"/>
      </div>
      <div>
        <span class="pick-your-size">${baseText.pickYourSize}</span>
        <span class="included">${baseText.includedPairs3}</span>
      </div>
      <a class="size-chart right-size-button"><span>${baseText.whatSizeIsRight}</span></a>
    `;
    socksSize.prepend(wrapper);
  }
}

if (document.body.classList.contains("5-silentball-grip-socks")) {
  const socksSize = document.querySelector(".variant-wrapper:first-child");
  if (socksSize) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("selection-wrapper");
    wrapper.innerHTML = `
      <div>
        <img src="https://cdn.shopify.com/s/files/1/0935/8707/9433/files/pick-your-size-socks.png?v=1754543659"/>
      </div>
      <div>
        <span class="pick-your-size">${baseText.pickYourSize}</span>
        <span class="included">${baseText.includedPairs5}</span>
      </div>
      <a class="size-chart right-size-button"><span>${baseText.whatSizeIsRight}</span></a>
    `;
    socksSize.prepend(wrapper);
  }
}

if (document.body.classList.contains("silentball-silent-basketball") || document.body.classList.contains("silentball")) {
  const ballSize = document.querySelector(".variant-wrapper:first-child");
  if (ballSize) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("selection-wrapper");
    wrapper.innerHTML = `
      <div>
        <img src="https://cdn.shopify.com/s/files/1/0935/8707/9433/files/pick-your-size-ball.png?v=1754543659"/>
      </div>
      <div>
        <span class="pick-your-size">${baseText.pickYourSize}</span>
        <span class="included">${baseText.includedBall1}</span>
      </div>
      <a class="size-chart right-size-button"><span>${baseText.whatSizeIsRight}</span></a>
    `;
    ballSize.prepend(wrapper);
  }

  const ballLabelMap = pvI18n.ballLabelMap || {
    "5 (3-11 yrs.)": ["Size 5", "Ages 3-11"],
    "6 (12-13 yrs.)": ["Size 6", "Ages 12-13"],
    "7 (14+ yrs.)": ["Size 7", "Ages 14+"]
  };

  Object.entries(ballLabelMap).forEach(([value, [main, sub]]) => {
    const container = document.querySelector(`.variant-input[data-value="${value}"]`);
    if (!container) return;

    const label = container.querySelector("label");
    if (!label) return;

    label.innerHTML = `
      <div class="size-description">
        <span>${main}</span>
        <span>${sub}</span>
      </div>
    `;
  });
}

/* Size guides */
const sgI18n = window.sizeGuidesI18n || {};
const SELECT_BALL_SIZE_TEXT = sgI18n.select_ball_size || 'Select SILENTBALL™ size';
const SIZE_GUIDE_TEXT = sgI18n.size_guide || 'Size guide';

if (
  document.body.classList.contains('silentball-advanced-bundle') ||
  document.body.classList.contains('silentball™-starter-bundle')
) {
  var ballSize = document.querySelector('.variant-wrapper:first-child');
  var ballSizeText = document.querySelector('.variant-wrapper:first-child .variant__label');

  if (ballSizeText) ballSizeText.textContent = SELECT_BALL_SIZE_TEXT;

  if (ballSize && !ballSize.querySelector('.size-chart')) {
    ballSize.insertAdjacentHTML(
      'afterbegin',
      `<a class="size-chart">${SIZE_GUIDE_TEXT}</a>`
    );
  }
}

var sizechartButton = document.querySelector('.size-chart');
var sizechartultimateButton = document.querySelector('.size-chart-ultimate');
var sizechart = document.querySelector('.size-chart-container');
var sizechartUltimate = document.querySelector('.size-chart-ultimate-container');
var sizechartClose = document.querySelectorAll('.size-chart-close');

if (sizechartButton && sizechart) {
  sizechartButton.addEventListener('click', function () {
    sizechart.classList.add('active');
  });

  const target = document.querySelector('.size-chart-container .size-chart-wrapper');
  document.addEventListener('click', (event) => {
    const path = event.composedPath ? event.composedPath() : [];
    const withinBoundaries = target ? path.includes(target) : false;
    const withinBoundaries1 = path.includes(sizechartButton);

    if (!withinBoundaries && !withinBoundaries1) {
      sizechart.classList.remove('active');
    }
  });
}

if (sizechartultimateButton && sizechartUltimate) {
  sizechartultimateButton.addEventListener('click', function () {
    sizechartUltimate.classList.add('active');
  });

  const targetUltimate = document.querySelector('.size-chart-ultimate-container .size-chart-wrapper');
  document.addEventListener('click', (event) => {
    const path = event.composedPath ? event.composedPath() : [];
    const withinBoundaries2 = targetUltimate ? path.includes(targetUltimate) : false;
    const withinBoundaries3 = path.includes(sizechartultimateButton);

    if (!withinBoundaries2 && !withinBoundaries3) {
      sizechartUltimate.classList.remove('active');
    }
  });
}

if (sizechartClose && sizechartClose.length) {
  for (var i = 0; i < sizechartClose.length; i++) {
    sizechartClose[i].onclick = function () {
      if (sizechart) sizechart.classList.remove('active');
      if (sizechartUltimate) sizechartUltimate.classList.remove('active');
    };
  }
}

/* Product tabs */
if (document.body.classList.contains('template-product')) {
  var lastTabArray = [...document.querySelectorAll('.product-block--tab')];
  var lastTab = lastTabArray.slice(-1)[0];
  if (lastTab) {
    lastTab.classList.add('last-tab');
  }
}

if (document.body.classList.contains('training-kit')) {
  var tabContent = document.querySelector('.collapsible-content .metafield-rich_text_field');
  var template = document.querySelector('#training-kit-dropdown-template');

  if (tabContent && template) {
    tabContent.innerHTML = template.innerHTML;
  }
}

/* Reviews */
var reviewsPreview = document.querySelectorAll('.jdgm-widget .jdgm-prev-badge');
var i18n = window.reviewsI18n || {};

if (reviewsPreview.length) {
  reviewsPreview.forEach(function (reviewsPreviewSingle) {
    var reviewCount =
      reviewsPreviewSingle.getAttribute('data-number-of-reviews') || '100';

    var reviewHtml = `
      <a href="#judgeme_product_reviews">
        ${i18n.based_on || 'based on'}
        <span class="review-count">${reviewCount}</span>
        ${i18n.reviews || 'reviews'}
      </a>
    `;

    reviewsPreviewSingle.insertAdjacentHTML('afterbegin', reviewHtml);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const badges = document.querySelectorAll(".jdgm-prev-badge");
  const isTrainingKit = document.body.classList.contains("training-kit");

  if (isTrainingKit) {
    badges.forEach((badge) => {
      const FORCE_TEXT = () => {
        const text = badge.querySelector(".jdgm-prev-badge__text");
        if (text && text.textContent !== "4.8") {
          text.textContent = "4.8";
        }
      };

      FORCE_TEXT();

      const mo = new MutationObserver(FORCE_TEXT);
      mo.observe(badge, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
    return;
  }

  badges.forEach((badge) => {
    const observer = new MutationObserver(() => {
      const stars = badge.querySelector(".jdgm-prev-badge__stars");
      const text = badge.querySelector(".jdgm-prev-badge__text");

      if (stars && text) {
        const score = stars.getAttribute("data-score");
        if (score) {
          text.textContent = score;
          observer.disconnect();
        }
      }
    });

    observer.observe(badge, { childList: true, subtree: true });
  });
});

/* Sticky add to cart */
window.addEventListener('scroll', function () {
  var stickyCart = document.querySelector('.sticky-add-to-cart');
  var productSection = document.querySelector('.product-section');
  if (productSection) {
    var productSectionOffset = productSection.offsetHeight;
  }
  if (stickyCart && productSectionOffset) {
    if (window.pageYOffset > productSectionOffset) {
        stickyCart.classList.add('active');
    } else {
        stickyCart.classList.remove('active');
    }
  }
})

/* Newsletter */
var newsletterForm = document.querySelector('.newsletter-section__content form');
var i18n = window.newsletterI18n || {};

if (newsletterForm) {
  if (!newsletterForm.previousElementSibling?.classList.contains('your-email')) {
    newsletterForm.insertAdjacentHTML(
      'beforebegin',
      `<span class="your-email">${i18n.your_email || 'Your email'}</span>`
    );
  }

  if (!newsletterForm.nextElementSibling?.classList.contains('agreement')) {
    newsletterForm.insertAdjacentHTML(
      'afterend',
      `<span class="agreement">${i18n.agreement_html || ''}</span>`
    );
  }
}

/* Product reviews carousel */
const reviewsSwiper = document.querySelector(
  ".reviews-swiper"
);

if (reviewsSwiper) {
  const ugcCarouselSlider = new Swiper(
    ".reviews-swiper",
    {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: ".reviews-slider-wrapper .swiper-pagination",
        clickable: true,
      },
    }
  );
}

/* UGC carousel */
const ugcSwiper1 = document.querySelector(
  ".ugc-swiper-1"
);

const ugcSwiper2 = document.querySelector(
  ".ugc-swiper-2"
);

if (ugcSwiper1) {
  const ugcCarouselSlider = new Swiper(
    ".ugc-swiper-1",
    {
      slidesPerView: 2.5,
      spaceBetween: 10,
      speed: 3000,
      loop: true,
      allowTouchMove: false,
      disableOnInteraction: true,
      autoplay: {
        delay: 1,
      },
      breakpoints: {
        769: {
          slidesPerView: 4,
        },
        1025: {
          slidesPerView: 7,
        },
        1440: {
          slidesPerView: 8,
        },
      },
    }
  );
}

if (ugcSwiper2) {
  const ugcCarouselSlider = new Swiper(
    ".ugc-swiper-2",
    {
      slidesPerView: 2.5,
      spaceBetween: 10,
      speed: 3000,
      loop: true,
      allowTouchMove: false,
      disableOnInteraction: true,
      autoplay: {
        delay: 1,
        reverseDirection: true,
      },
      breakpoints: {
        769: {
          slidesPerView: 4,
        },
        1025: {
          slidesPerView: 7,
        },
        1440: {
          slidesPerView: 8,
        },
      },
    }
  );
}

/* Image protection */
document.addEventListener("DOMContentLoaded", function () {

  document.addEventListener("contextmenu", function (e) {
    if (e.target.tagName === "IMG") {
      e.preventDefault();
    }
  });

  document.addEventListener("dragstart", function (e) {
    if (e.target.tagName === "IMG") {
      e.preventDefault();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (
      e.key === "F12" ||
      (e.ctrlKey && e.shiftKey && e.key === "I") ||
      (e.ctrlKey && e.shiftKey && e.key === "J") ||
      (e.ctrlKey && e.key === "U")
    ) {
      e.preventDefault();
    }
  });

});

/* Subscription text change */
document.addEventListener("DOMContentLoaded", function () {
  function decodeHtml(str) {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  }

  function updateSubscriptionButton() {
    const btnText = document.querySelector('[data-add-to-cart-text]');
    if (!btnText) return;

    if (document.body.classList.contains('subscription')) {
      btnText.textContent = decodeHtml(
        window.theme?.strings?.subscription || 'Subscribe & Save'
      );
    } else {
      btnText.textContent = btnText.dataset.defaultText || 'Add to cart';
    }
  }

  updateSubscriptionButton();
  document.addEventListener('variant:change', updateSubscriptionButton);
});